export default ['$q', 'addresslookup.AddressLookupService', function ($q, AddressLookupService) {
    return {
        lookupAddress: function lookupAddress(addressString, addressSettings) {
            var containsTooFewCharacters = addressString && addressString.length < addressSettings.minimumCharactersBeforeSearching;

            if (!addressString || containsTooFewCharacters) {
                return [];
            }
            var deferred = $q.defer();

            AddressLookupService.autofillBasedOnAdddress(addressString).then(function (addressInfo) {
                if (addressInfo && addressInfo.matches && addressInfo.matches.length > 0) {
                    var sortedMatches = addressInfo.matches.sort(function (foundAddressA, foundAddressB) {
                        return foundAddressA.matchAccuracy < foundAddressB.matchAccuracy;
                    });
                    var sortedAddresses = sortedMatches.map(function (elem) {
                        return elem.address;
                    });

                    deferred.resolve(sortedAddresses);
                } else {
                    deferred.reject();
                }
            }, function () {
                deferred.reject();
            });
            return deferred.promise;
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/addresslookup/util/AddressSearchUtil.js
// module id = 874
// module chunks = 0